module.exports = __webpack_public_path__ + "assets/platform-seta-selec.1fb97193.svg";